import { getQueryFormatForUserAPI } from "../../Orders/api";
import { sendCalculatorDataAPI, userFleetsAPI } from "../api";

export const fetchCargoDetails = (data) => {
  return new Promise((resolve, reject) => {
    getQueryFormatForUserAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const fetchVesselDetails = (data) => {
  return new Promise((resolve, reject) => {
    userFleetsAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const sendCalculatorData = (data) => {
  return new Promise((resolve, reject) => {
    sendCalculatorDataAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};